// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1243":"ed5688a1","5160":"9276b2b1","6929":"ed06f95c"}[chunkId] + ".css";
};